import SubtleBadge from "components/common/SubtleBadge";
import { multiSelectStyles } from "components/olitask/donations/credits/selectStyles";
import useRoles from "hooks/access-control/useRoles";
import React from "react";
import { Button, Col } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import { Button as ButtonAntd } from "antd";

export default function AssignedRoles({
  selectedUser,
  handleRoleChange,
  enableEdit,
  setEnableEdit,
  preSelectedRoles,
  removedItemIds,
  handleRemoveRoles,
  cancelEdit,
  submitting,
}) {
  const { roles } = useRoles();

  return (
    <Col className="col-12 mb-3">
      <div className="d-flex justify-content-between align-items-center">
        <p className="form-label text-xxs">Assigned Roles</p>

        <div>
          {selectedUser && !enableEdit && preSelectedRoles.length > 0 && (
            <Button
              variant="link"
              className="text-xxs p-0 text-danger underline"
              onClick={() => setEnableEdit(true)}
            >
              Remove roles
            </Button>
          )}

          {selectedUser && enableEdit && (
            <>
              <Button
                variant="link"
                className="text-xxs p-0"
                onClick={cancelEdit}
              >
                Cancel
              </Button>
            </>
          )}
        </div>
      </div>

      <AsyncSelect
        isMulti
        cacheOptions
        defaultOptions={preSelectedRoles?.map((role) => ({
          value: role.id,
          label: role.name,
        }))}
        value={preSelectedRoles}
        onChange={(options) => handleRoleChange(options)}
        placeholder="Select user to load assigned roles"
        styles={multiSelectStyles}
        isDisabled={!enableEdit}
        className="text-sm fw-semibold"
      />

      {enableEdit && removedItemIds.length === 0 && (
        <p className="text-xxs mb-1 mt-2">Select roles to remove</p>
      )}

      {enableEdit && removedItemIds.length > 0 && (
        <div className="mt-2">
          <p className="text-xxs text-danger mb-1">Roles marked for removal:</p>
          <div className="text-sm text-danger">
            {removedItemIds.map((id) => {
              const item = roles.find((r) => r.id === id);
              return (
                <SubtleBadge pill key={id} className="me-2">
                  {item?.name}
                </SubtleBadge>
              );
            })}
          </div>

          <div className="d-flex align-items-end justify-content-between mt-3">
            <div>
              <ButtonAntd
                variant="secondary"
                size="sm"
                onClick={cancelEdit}
                className="text-nowrap text-xxs bg-secondary text-white"
              >
                Cancel
              </ButtonAntd>
              {submitting ? (
                <ButtonAntd
                  type="primary"
                  loading
                  iconPlacement="end"
                  size="sm"
                  className="ms-2 bg-success"
                  style={{ fontFamily: "Inter" }}
                >
                  Saving
                </ButtonAntd>
              ) : (
                <ButtonAntd
                  variant="success"
                  size="sm"
                  onClick={handleRemoveRoles}
                  className="text-nowrap text-xxs ms-2 bg-success text-white"
                >
                  Save
                </ButtonAntd>
              )}
            </div>
          </div>
        </div>
      )}
    </Col>
  );
}
